function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import OrderItem from "@common/components/order/OrderItem";
import AdditionalItemsOverlay from "@common/components/order/subscriptions/AdditionalItemsOverlay";
import { isEmpty } from "lodash";
import React, { Component } from "react";
import ChannelLogo from "@common/components/ChannelLogo";
import ActivityIndicator from "@common/components/order/subscriptions/ActivityIndicator";
import { formatPrice } from "@common/services/helpers";
import { getItemPrice } from "@common/utils/helpers";
import { connect } from "react-redux";
var MAX_CHANNELS_TO_SHOW_DESKTOP = 11;
var MAX_CHANNELS_TO_SHOW_MOBILE = 7;
var SubscriptionItem = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(SubscriptionItem, Component);
    var _super = _create_super(SubscriptionItem);
    function SubscriptionItem() {
        _class_call_check(this, SubscriptionItem);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "getMaxChannelsToShow", function() {
            var screenType = _this.props.screenType;
            return screenType.web || screenType.tablet ? MAX_CHANNELS_TO_SHOW_DESKTOP : MAX_CHANNELS_TO_SHOW_MOBILE;
        });
        _define_property(_assert_this_initialized(_this), "renderChannels", function() {
            var _this_props = _this.props, subscription = _this_props.subscription, logos = _this_props.logos;
            if (isEmpty(subscription === null || subscription === void 0 ? void 0 : subscription.metaData)) return null;
            return subscription.metaData.channels.slice(0, _this.getMaxChannelsToShow()).map(function(subscriptionChannelId) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "channel-logo",
                    children: /*#__PURE__*/ _jsx(ChannelLogo, {
                        hasName: false,
                        channelLogo: logos[subscriptionChannelId],
                        isCentered: true,
                        redirectToChannel: false,
                        isInSubscriptionPage: true
                    })
                }, subscriptionChannelId);
            });
        });
        _define_property(_assert_this_initialized(_this), "renderPrice", function() {
            var _this_props_billingAddress, _this_props_billingAddress1;
            var _this_props = _this.props, _this_props_subscription = _this_props.subscription, subscription = _this_props_subscription === void 0 ? {} : _this_props_subscription, i18n = _this_props.i18n, _this_props_subscriptionPrismic = _this_props.subscriptionPrismic, subscriptionPrismic = _this_props_subscriptionPrismic === void 0 ? {} : _this_props_subscriptionPrismic, currencyConversion = _this_props.currencyConversion, userDetails = _this_props.userDetails;
            var price = subscription.price;
            var _getItemPrice = getItemPrice(subscription, subscriptionPrismic, currencyConversion), originalPrice = _getItemPrice.originalPrice, discountedPrice = _getItemPrice.discountedPrice, hasPromoPrice = _getItemPrice.hasPromoPrice, currencyCode = _getItemPrice.currencyCode;
            var inEuro = getItemPrice(subscription, subscriptionPrismic, currencyConversion, true);
            var _ref;
            var showEuro = currencyConversion && ((_ref = ((_this_props_billingAddress = _this.props.billingAddress) === null || _this_props_billingAddress === void 0 ? void 0 : _this_props_billingAddress.country) === 'BG' || ((_this_props_billingAddress1 = _this.props.billingAddress) === null || _this_props_billingAddress1 === void 0 ? void 0 : _this_props_billingAddress1.country) === 'Bulgaria') !== null && _ref !== void 0 ? _ref : (userDetails === null || userDetails === void 0 ? void 0 : userDetails.predifinedCountryCode) === 'BG');
            var isFree = price === 0;
            return /*#__PURE__*/ _jsxs("div", {
                className: "column end",
                children: [
                    !isFree && hasPromoPrice && /*#__PURE__*/ _jsx("span", {
                        className: "original-price",
                        children: formatPrice(originalPrice, currencyCode)
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "discounted-price",
                        children: !isFree ? /*#__PURE__*/ _jsx(_Fragment, {
                            children: formatPrice(discountedPrice, currencyCode)
                        }) : "FREE"
                    }),
                    showEuro && /*#__PURE__*/ _jsxs("span", {
                        className: "discounted-price euro",
                        children: [
                            "".concat(formatPrice(inEuro.hasPromoPrice ? inEuro.discountedPrice : inEuro.originalPrice, "EUR")),
                            /*#__PURE__*/ _jsx("span", {
                                className: "eu-icon"
                            })
                        ]
                    })
                ]
            });
        });
        _define_property(_assert_this_initialized(_this), "renderPriceAndRadioButton", function() {
            var _this_props = _this.props, active = _this_props.active, status = _this_props.status;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    isEmpty(status) ? _this.renderPrice() : /*#__PURE__*/ _jsx(ActivityIndicator, {
                        status: status
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "radio-button ".concat(active ? "active" : "")
                    })
                ]
            });
        });
        return _this;
    }
    _create_class(SubscriptionItem, [
        {
            key: "render",
            value: function render() {
                var _subscription_metaData_channels, _subscription_metaData;
                var _this_props = this.props, subscription = _this_props.subscription, _this_props_single = _this_props.single, single = _this_props_single === void 0 ? false : _this_props_single, i18n = _this_props.i18n, _this_props_active = _this_props.active, active = _this_props_active === void 0 ? false : _this_props_active, onClick = _this_props.onClick, _this_props_subscriptionPrismic = _this_props.subscriptionPrismic, subscriptionPrismic = _this_props_subscriptionPrismic === void 0 ? {} : _this_props_subscriptionPrismic, onAdditionalItemClick = _this_props.onAdditionalItemClick, // plain clears payment info
                plain = _this_props.plain, renderTopRightCornerExtra = _this_props.renderTopRightCornerExtra;
                if (isEmpty(subscriptionPrismic)) {
                    return null;
                }
                var banner = subscriptionPrismic.banner, title = subscriptionPrismic.title, subtitle = subscriptionPrismic.subtitle, subtitle_color = subscriptionPrismic.subtitle_color, perks_title = subscriptionPrismic.perks_title;
                var hasAdditionalChannels = !isEmpty(subscription === null || subscription === void 0 ? void 0 : subscription.metaData) && subscription.metaData.channels.length > this.getMaxChannelsToShow();
                var perkItems = Object.entries(subscriptionPrismic).filter(function(param) {
                    var _param = _sliced_to_array(param, 1), key = _param[0];
                    return key.includes("perk_item_");
                }).map(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    return _object_spread_props(_object_spread({}, value), {
                        key: key
                    });
                });
                return /*#__PURE__*/ _jsx(OrderItem, {
                    single: single,
                    onClick: onClick,
                    active: active,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "subscription-item",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "top",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "plan-title-container column",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "plan-title",
                                                children: title.text
                                            }),
                                            !plain && /*#__PURE__*/ _jsx("span", {
                                                className: "plan-subtitle",
                                                style: {
                                                    color: subtitle_color
                                                },
                                                children: subtitle.text
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "row justify-content-end",
                                        children: [
                                            renderTopRightCornerExtra === null || renderTopRightCornerExtra === void 0 ? void 0 : renderTopRightCornerExtra(),
                                            !plain && this.renderPriceAndRadioButton()
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "bottom",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "bottom-section-content",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "bottom-section-title",
                                                children: perks_title.text
                                            }),
                                            perkItems.map(function(perk) {
                                                return !isEmpty(perk === null || perk === void 0 ? void 0 : perk.text) && /*#__PURE__*/ _jsxs("span", {
                                                    className: "bottom-section-text",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "icon icon-done check"
                                                        }),
                                                        perk === null || perk === void 0 ? void 0 : perk.text
                                                    ]
                                                }, perk === null || perk === void 0 ? void 0 : perk.key);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "channels",
                                        children: this.renderChannels()
                                    }),
                                    hasAdditionalChannels && /*#__PURE__*/ _jsx(AdditionalItemsOverlay, {
                                        channelsCount: (subscription === null || subscription === void 0 ? void 0 : (_subscription_metaData = subscription.metaData) === null || _subscription_metaData === void 0 ? void 0 : (_subscription_metaData_channels = _subscription_metaData.channels) === null || _subscription_metaData_channels === void 0 ? void 0 : _subscription_metaData_channels.length) - this.getMaxChannelsToShow(),
                                        onClick: onAdditionalItemClick
                                    })
                                ]
                            }),
                            (banner === null || banner === void 0 ? void 0 : banner.url) && !plain && /*#__PURE__*/ _jsx("img", {
                                className: "banner",
                                src: banner.url
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return SubscriptionItem;
}(Component);
var mapStateToProps = function(param) {
    var logos = param.logos, i18n = param.i18n, screenType = param.screenType, userDetails = param.userDetails;
    return {
        logos: logos,
        i18n: i18n,
        screenType: screenType,
        userDetails: userDetails
    };
};
export default connect(mapStateToProps, {})(SubscriptionItem);
